module.exports = __webpack_public_path__ + "img/9.4d0e0b24.jpg";